<template>
  <th
    :class="[
      alignCustomize,
      '   bg-ontick-graphite px-3 py-4 text-xs font-bold uppercase leading-4 text-white ',
    ]"
  >
    <slot></slot>
  </th>
</template>

<script>
export default {
  name: "ontick-table-th",
  props: {
    align: {
      type: String,
      default: "left",
      validator: function (value) {
        return ["left", "center", "right"].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    alignCustomize() {
      return {
        "text-left": this.align == "left",
        "text-center": this.align == "center",
        "text-right": this.align == "right",
      };
    },
  },
};
</script>

<style></style>
